import axios from '../utils/axios';

export default function postResumeBuilderCandidate(data) {
    return (
        axios.post('/resumeBuilder/resume/activateUser',  data )
        .then(res => {
            return res
        })
        .catch(err => {
            return err;
        })
    )
}
